<template>
    <div class="page" style="max-width: 600px">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h4 class="page-title" id="page_title">Company</h4>
                </div>
            </div>
        </div>
        <div class="card card-body m-0">
            <div class="text-center mb-3">
                <img :src="logo_image_path ? logo_image_path : '/images/user-4.jpg'"
                     @click="addLogo"
                     class="img-thumbnail logo-image"
                     data-holder-rendered="true">
                <input @change="onLogoChange"
                       accept="image/*"
                       ref="logoFileInput"
                       type='file'
                       v-show="false"/>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-lg-4 col-form-label">Name:</label>
                <div class="col-sm-7 col-lg-8">
                    <input :class="{ 'parsley-error' : form.errors.has('name') }"
                           class="form-control"
                           placeholder="Enter company name"
                           title="Company name"
                           type="text"
                           v-model="form.name">
                    <ul :class="{'filled' : form.errors.has('name')}"
                        class="parsley-errors-list">
                        <li class="parsley-required">
                            {{ form.errors.get('name') }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-lg-4 col-form-label">Email:</label>
                <div class="col-sm-7 col-lg-8">
                    <input :class="{ 'parsley-error' : form.errors.has('email') }"
                           class="form-control"
                           placeholder="Enter company email"
                           title="Company email"
                           type="text"
                           v-model="form.email">
                    <ul :class="{'filled' : form.errors.has('email')}"
                        class="parsley-errors-list">
                        <li class="parsley-required">
                            {{ form.errors.get('email') }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-lg-4 col-form-label">Phone Number:</label>
                <div class="col-sm-7 col-lg-8">
                    <input :class="{ 'parsley-error' : form.errors.has('phone_number') }"
                           class="form-control"
                           placeholder="Enter phone number"
                           title="Phone number"
                           type="text"
                           v-model="form.phone_number">
                    <ul :class="{'filled' : form.errors.has('phone_number')}"
                        class="parsley-errors-list">
                        <li class="parsley-required">
                            {{ form.errors.get('phone_number') }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-lg-4 col-form-label">Address:</label>
                <div class="col-sm-7 col-lg-8">
                    <input :class="{ 'parsley-error' : form.errors.has('address') }"
                           class="form-control"
                           placeholder="Enter company address"
                           title="Company address"
                           type="text"
                           v-model="form.address">
                    <ul :class="{'filled' : form.errors.has('address')}"
                        class="parsley-errors-list">
                        <li class="parsley-required">
                            {{ form.errors.get('address') }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="text-center mt-3">
                <button :disabled="form.busy"
                        @click="submit()"
                        class="btn btn-primary waves-effect waves-light"
                        type="button">
                    <i class="mdi mdi-content-save"/>
                    Save changes
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Actions from "@/constants/store/actions";

    export default {
        data() {
            return {
                form: new Form({
                    logo: null,
                    name: null,
                    email: null,
                    phone_number: null,
                    address: null,
                }, {
                    name: 'required|string|max:255',
                    email: 'required|email|max:255',
                    phone_number: 'string|max:255',
                    address: 'string|max:255'
                }),
                company: null,
                logo_image_path: null
            }
        },
        mounted() {
            this.company = this.$store.state.user.companies[0];
            this.form = _.extend(this.form, _.pick(this.company, ['name', 'email', 'phone_number', 'address']));
            this.logo_image_path = this.company.logo;
        },
        methods: {
            addLogo() {
                this.$refs.logoFileInput.click();
            },
            onLogoChange(e) {
                if (!e.target.files.length) {
                    return;
                }
                this.form.logo = e.target.files[0];
                this.logo_image_path = URL.createObjectURL(this.form.logo);
            },
            submit() {
                this.form.validate()
                    .then(() => {
                        this.$confirm('Are you sure to save changes?', 'Confirm', {
                            confirmButtonText: 'OK',
                            cancelButtonText: 'Cancel',
                            type: 'info'
                        }).then(() => {
                            App.putData('/web-api/company/' + this.company.id, this.form)
                                .then(() => {
                                    this.$store.dispatch(Actions.refresh_auth_user);
                                    this.$notify({
                                        title: 'Success',
                                        message: 'Successfully updated company profile.',
                                        type: 'success'
                                    });
                                })
                        });
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .logo-image {
        width: 150px;
        height: 150px;
        object-fit: cover;
        cursor: pointer;
    }
</style>
